import { Controller } from '@hotwired/stimulus'

// A data-sheet value stays on one line, cut with an ellipsis, and never moves
// when the pointer does. The expand button in its pill opens the whole value on
// a click and closes it on the next; it shows only for a value that is cut.
export default class extends Controller {
  static targets = ['button']

  connect () {
    this.observer = new ResizeObserver(() => this.sync())
    this.observer.observe(this.element)
    this.sync()
  }

  disconnect () {
    this.observer?.disconnect()
  }

  toggle (event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.toggleAttribute('data-expanded')
    this.sync()
  }

  sync () {
    const open = this.element.hasAttribute('data-expanded')
    const cut = this.element.scrollWidth > this.element.clientWidth + 1
    this.buttonTarget.hidden = !(open || cut)
    this.buttonTarget.setAttribute('aria-expanded', String(open))
    this.buttonTarget.title = open ? 'Show less' : 'Show all'
    const icon = this.buttonTarget.querySelector('i')
    if (icon) icon.className = `ti ${open ? 'ti-chevron-up' : 'ti-chevron-down'}`
  }
}
